import iq_api_v2 from "../../../../../services/iqApiV2";
import { CREATE_DEAL_REQUEST, createDealFailure, createDealSuccess } from "../../../actions/opportunities/increaseDealSizeActions/createDealActions";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { LIST_DEALS_REQUEST, listDealsRequest, listDealsRequestPlain } from "../../../actions/opportunities/increaseDealSizeActions/listDealsActions";
import { bannerService } from "../../../../../context/BannerContext";

//opportunityIds ['6814ac4639348bef5268335d', '6814ac4639348bef5268335e', '6814ac4639348bef5268335f']

async function CreateDeal(opportunityIds, userId,clientName,accountName) {
    const formData = new FormData();
    formData.append("opportunity_ids", opportunityIds?.flat().join(","));
    formData.append("user_id", userId);
    formData.append("client", clientName);
    formData.append("account", accountName);
  
    try {
      const response = await iq_api_v2.post(
        '/deals/create_deal',
        formData, // send as form data
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      );
      return response?.data;
    } catch (error) {
      console.error('Error:', error.response ? error.response.data : error.message);
      throw error;
    }
  }
  
  
  function* createDealSaga() {
    try {
      const payload = yield select((state) => state?.createDealReducer?.payload);
      const { opportunityIds, userId, clientName, accountName } = payload;
      const data = yield call(CreateDeal, opportunityIds, userId, clientName, accountName);
      yield put(createDealSuccess(data));
           yield call(
                [bannerService, bannerService.publish],
                {
                  message:
                  "Deal Created",
                  title:"Alert",
                  type: 'info',
                  duration: 2000
                }
              )
      yield put(listDealsRequestPlain({ userId ,clientName, accountName}));
      
    } catch (error) {
      yield put(createDealFailure(error.message));
    }
  }
  

// Watcher Saga
export function* watchCreateDealSaga() {
  yield takeLatest(CREATE_DEAL_REQUEST, createDealSaga);
}
